import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import { trackPromotionClick } from 'helpers'
import * as Layouts from 'layouts'
import * as Helpers from 'helpers'

export class FOURTY_ANNIVERSARY extends React.PureComponent<FOURTY_ANNIVERSARY.Props, FOURTY_ANNIVERSARY.State> {
  public static sectionId = 'fourtya';

  public render(): JSX.Element {
    const { section } = this.props
    const { settings, blocks } = section
    

    if (!settings) {
      return <React.Fragment/>
    }

    let last = 1

    return (
      <section className={'max-w-container mx-auto'}>
        <div className={'max-w-7xl px-1-6 xl:px-0 mx-auto pt-1 md:pt-3-2 pb-6-4'}>
          <div className="w-full flex justify-center">
            <Snippets.Heading size={'h1'} tag={'h1'} className={settings.textblock ? 'mb-1-6 md:mb-2-4 text-center leading-none md:leading-tight' : 'mb-2-5 md:mb-3-2 text-center leading-none md:leading-tight'}>
              { settings.title }
            </Snippets.Heading>
          </div>
          <div className="flex w-full justify-center">
            <Snippets.RichText size={'p'} className={'mb-2-5 md:mb-3-2 px-1-2 md:px-4 font-mono'}>
              { settings.textblock }
            </Snippets.RichText>
          </div>
          <div className="w-full flex flex-col">
            {blocks && blocks.map((block, idx) => {
              const article1 = {
                title: block.settings.imageonetitle,
                image: block.settings.imageone,
                excerpt: block.settings.imageoneexcerpt,
                url: block.settings.imageonelink
              }
              const article2 = {
                title: block.settings.imagetwotitle,
                image: block.settings.imagetwo,
                excerpt: block.settings.imagetwoexcerpt,
                url: block.settings.imagetwolink
              }
              if (!article2?.image) {
                return (
                  <div className={'max-w-full w-full flex justify-center items-center mt-4'}>
                    <Snippets.FourtyAnCard imageWidth={1016} ratio={56} article={article1}/>
                  </div>

                )
              } else if (last === 1) {
                last = 0
                return (
                  <div className={'w-full flex flex-col md:flex-row md:items-center'}>
                    <div className={'w-8/12 md:w-1/2'} style={{
                      maxWidth: '496px'
                    }}>
                      <Snippets.FourtyAnCard imageWidth={496} ratio={115} article={article1}/>
                    </div>
                    <div className={'ml-auto w-9/12 md:w-1/2'} style={{
                      maxWidth: '600px'
                    }}>
                      <Snippets.FourtyAnCard imageWidth={600} ratio={135} article={article2}/>
                    </div>
                  </div>
                )
              } else if (last === 0) {
                last = 1
                return (
                  <div className={'w-full flex flex-col md:flex-row'}>
                    <div className={'w-9/12 md:w-1/2 md:pt-8'} style={{
                      maxWidth: '496px'
                    }}>
                      <Snippets.FourtyAnCard imageWidth={496} ratio={139} article={article1}/>
                    </div>
                    <div className={'ml-auto w-9/12 md:w-1/2 flex justify-end'} style={{
                      maxWidth: '392px'
                    }}>
                      <Snippets.FourtyAnCard imageWidth={392} ratio={115} article={article2}/>
                    </div>
                  </div>

                )
              }
            })}
          </div>
        </div>
      </section>
    )
  }
}

export namespace FOURTY_ANNIVERSARY {
  export type Options = ShopifyNext.Section<{
    imagesbl?: any
    title?: any
    textblock?: any
  }>;
  export interface Props extends GlobalProps {
    section: FOURTY_ANNIVERSARY.Options;
  }
  export interface State {}
}
